"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRangeAssigned = void 0;
function isAssigned(object) {
    return ((object?.nbAtoms && object.nbAtoms > 0) ||
        (object?.diaIDs && object.diaIDs.length > 0));
}
function isRangeAssigned(range) {
    if (isAssigned(range)) {
        return true;
    }
    return range?.signals.some((signal) => isAssigned(signal));
}
exports.isRangeAssigned = isRangeAssigned;
